/**
 * @generated SignedSource<<d99e8df91b284834aeb6b0a3cee688b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ChangedChannels = {
  id: string;
  order: number;
};
export type LibraryPanelReorderChannelMutation$variables = {
  changedChannels: ReadonlyArray<ChangedChannels | null>;
};
export type LibraryPanelReorderChannelMutation$data = {
  readonly reorderChannel: {
    readonly ok: boolean;
  } | null;
};
export type LibraryPanelReorderChannelMutation = {
  response: LibraryPanelReorderChannelMutation$data;
  variables: LibraryPanelReorderChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "changedChannels"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "changedChannels",
        "variableName": "changedChannels"
      }
    ],
    "concreteType": "ReorderChannel",
    "kind": "LinkedField",
    "name": "reorderChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LibraryPanelReorderChannelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LibraryPanelReorderChannelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a9f780361c7a1b71ce149dac23f614c2",
    "id": null,
    "metadata": {},
    "name": "LibraryPanelReorderChannelMutation",
    "operationKind": "mutation",
    "text": "mutation LibraryPanelReorderChannelMutation(\n  $changedChannels: [ChangedChannels]!\n) {\n  reorderChannel(changedChannels: $changedChannels) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d8595e8853023160f702024c57e52c3";

export default node;
